import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import PageHeader from './PageHeader';
import MetricCard from './MetricCard';
import RedemptionsChart from './charts/RedemptionsChart';
import RedemptionsByTypeChart from './charts/RedemptionsByTypeChart';
import RewardDetailDrawer from './RewardDetailDrawer';
import { AISidebar, AIRecommendationPanel } from './ai';
import { Award, Users, Coins, Gift, Plus, Play, Pause, Calendar, SkipBack, Gem } from 'lucide-react';
import { redemptionsOverTime, redemptionsByType, topRewards } from '../utils/mockData';
const Dashboard = () => {
  const navigate = useNavigate();
  const [selectedReward, setSelectedReward] = useState<any>(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isAISidebarOpen, setIsAISidebarOpen] = useState(false);
  const handleRewardClick = (reward: any) => {
    setSelectedReward(reward);
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setTimeout(() => setSelectedReward(null), 300);
  };
  const handleCreateReward = () => {
    navigate('/rewards/new');
  };
  const getStatusIcon = (status: string) => {
    switch (status) {
      case 'Attivo':
        return <Play className="h-4 w-4 text-green-600" data-id="element-434" />;
      case 'Programmato':
        return <Calendar className="h-4 w-4 text-blue-600" data-id="element-435" />;
      case 'In Scadenza':
        return <Pause className="h-4 w-4 text-amber-600" data-id="element-436" />;
      case 'Esaurito':
        return <SkipBack className="h-4 w-4 text-gray-600" data-id="element-437" />;
      default:
        return null;
    }
  };
  return <div className="flex h-screen bg-gray-50" data-id="element-438">
      <div className="w-20 flex-shrink-0" data-id="element-439">
        <Sidebar data-id="element-440" />
      </div>

      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-441">
        <Topbar data-id="element-442" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-443">
          <div className="flex items-center justify-between mb-6" data-id="element-444">
            <div data-id="element-445">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-446">Panoramica</h1>
              <p className="text-sm text-gray-500 mt-1" data-id="element-447">
                Andamento sintetico e azioni rapide.
              </p>
            </div>
            <div className="flex items-center gap-3" data-id="element-448">
              <div style={{
              background: 'linear-gradient(90deg, rgba(255, 0, 77, 1) 0%, rgba(116, 10, 214, 1) 50%, rgba(116, 10, 214, 1) 100%)',
              padding: '1px',
              borderRadius: '100px'
            }} data-id="element-449">
                <button onClick={() => setIsAISidebarOpen(true)} className="text-black transition-colors flex items-center gap-1.5 bg-white px-4 py-2 hover:bg-gray-50" style={{
                borderRadius: '100px'
              }} title="AI Insights" data-id="element-450">
                  <span className="text-sm" data-id="element-451">Suggerimenti AI</span>
                </button>
              </div>
              <button onClick={handleCreateReward} className="inline-flex items-center px-4 py-2 bg-greenback text-white text-sm font-medium hover:bg-greenback-600 transition-colors" style={{
              borderRadius: '100px'
            }} data-id="element-452">
                <Plus className="h-4 w-4 mr-2" data-id="element-453" />
                Crea Premio
              </button>
            </div>
          </div>

          <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-454">
            <MetricCard title="Riscatti" value="817" change="12.5%" isPositive={true} icon={Award} data-id="element-455" />
            <MetricCard title="Utenti Unici" value="342" change="8.2%" isPositive={true} icon={Users} data-id="element-456" />
            <MetricCard title="Punti Spesi" value="49,660" change="15.3%" isPositive={true} icon={Coins} data-id="element-457" />
            <MetricCard title="Premi Attivi" value="28" change="3" isPositive={true} icon={Gift} data-id="element-458" />
          </div>

          <div className="mb-8 grid grid-cols-1 gap-6 lg:grid-cols-2" data-id="element-459">
            <RedemptionsChart data={redemptionsOverTime} data-id="element-460" />
            <RedemptionsByTypeChart data={redemptionsByType} data-id="element-461" />
          </div>

          <div className="rounded-lg border border-gray-200 bg-white" data-id="element-462">
            <div className="px-6 py-4 border-b border-gray-200" data-id="element-463">
              <h3 className="text-lg font-semibold" data-id="element-464">Top Premi</h3>
            </div>
            <div className="overflow-x-auto" data-id="element-465">
              <table className="w-full" data-id="element-466">
                <thead data-id="element-467">
                  <tr className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-468">
                    <th className="px-6 py-3" data-id="element-469">Premio</th>
                    <th className="px-6 py-3" data-id="element-470">Stato</th>
                    <th className="px-6 py-3" data-id="element-471">Riscatti (Periodo)</th>
                    <th className="px-6 py-3" data-id="element-472">Punti Spesi</th>
                    <th className="px-6 py-3" data-id="element-473">Ultimo Riscatto</th>
                    <th className="px-6 py-3" data-id="element-474">Azioni</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200" data-id="element-475">
                  {topRewards.map(reward => <tr key={reward.id} className="hover:bg-gray-50 cursor-pointer" onClick={() => handleRewardClick(reward)} data-id="element-476">
                      <td className="px-6 py-4" data-id="element-477">
                        <div className="font-medium text-gray-900" data-id="element-478">
                          {reward.name}
                        </div>
                        <div className="text-sm text-gray-500" data-id="element-479">
                          {reward.category}
                        </div>
                      </td>
                      <td className="px-6 py-4" data-id="element-480">
                        <div className="inline-flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 cursor-help" title={reward.status} data-id="element-481">
                          {getStatusIcon(reward.status)}
                        </div>
                      </td>
                      <td className="px-6 py-4 font-medium" data-id="element-482">
                        {reward.redemptions}
                      </td>
                      <td className="px-6 py-4 font-medium" data-id="element-483">
                        <div className="flex items-center gap-1" data-id="element-484">
                          <Gem className="h-3.5 w-3.5 text-gray-500" data-id="element-485" />
                          <span data-id="element-486">{reward.diamondsSpent.toLocaleString()}</span>
                        </div>
                      </td>
                      <td className="px-6 py-4 text-gray-500" data-id="element-487">
                        {reward.lastRedemption}
                      </td>
                      <td className="px-6 py-4" data-id="element-488">
                        <button onClick={e => {
                      e.stopPropagation();
                      handleRewardClick(reward);
                    }} className="text-greenback hover:text-greenback-600 font-medium text-sm" data-id="element-489">
                          Dettagli
                        </button>
                      </td>
                    </tr>)}
                </tbody>
              </table>
            </div>
          </div>
        </main>
      </div>

      {/* AI Sidebar */}
      <AISidebar isOpen={isAISidebarOpen} onClose={() => setIsAISidebarOpen(false)} title="Suggerimenti AI per la Dashboard" data-id="element-490">
        <AIRecommendationPanel recommendations={[{
        id: '1',
        title: 'Ottimizza fascia 40-60 punti',
        type: 'Opportunità',
        diamondRange: '40-60 punti',
        reason: "I riscatti sono aumentati del 12.5%. Questa fascia ha il miglior tasso di conversione. Crea nuovi premi in questo range per massimizzare l'engagement.",
        ctaLabel: 'Crea premio',
        onCtaClick: () => navigate('/rewards/new')
      }, {
        id: '2',
        title: 'Capitalizza crescita utenti',
        type: 'Strategia',
        diamondRange: '+8.2% utenti attivi',
        reason: "Gli utenti unici sono cresciuti dell'8.2%. Lancia premi esclusivi per nuovi utenti o programmi fedeltà per consolidare la retention.",
        ctaLabel: 'Vedi insights',
        onCtaClick: () => navigate('/insights')
      }]} lastUpdated="Ultimi 30 giorni" data-id="element-491" />
      </AISidebar>

      <RewardDetailDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer} reward={selectedReward} data-id="element-492" />
    </div>;
};
export default Dashboard;